import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';

interface UnacknowledgedWorkoutsResponse {
  workouts: any[];
  weeklyStats: {
    totalDistance: number;
    totalTime: number;
    workoutCount: number;
  };
}

export const useUnacknowledgedWorkouts = (): UseQueryResult<{
  workouts: any[];
}> => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: ['unacknowledgedWorkouts'],
    queryFn: async (): Promise<UnacknowledgedWorkoutsResponse> => {
      const token = await getAccessTokenSilently();
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/workouts/unacknowledged`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error('Failed to fetch unacknowledged workouts');
      }

      return response.json();
    },
    enabled: isAuthenticated,
    staleTime: 0, // Always fetch fresh data
    refetchOnWindowFocus: false,
  });
};
